import React, { FC, useContext } from 'react'

import CheckoutNavigationBar from '../../components/buy/checkout/CheckoutNavigationBar'
import PromoCodeContainer from '../../components/buy/promo_code/PromoCodeContainer'
import CartItemsSummary from '../../components/buy/summary/CartItemsSummary'
import { OrderSummary } from '../../components/buy/summary/OrderSummary'
import { NonEmptyCartContext } from '../../lib/cart'
import LeftHalfLayout from './LeftHalfLayout'
import RightHalfLayout from './RightHalfLayout'

export interface CheckoutLayoutProps {
  className?: string
  checkoutNavigationBarTabValue: number
}

const CheckoutLayout: FC<CheckoutLayoutProps> = ({
  children,
  className,
  checkoutNavigationBarTabValue,
}) => {
  const customerCart = useContext(NonEmptyCartContext)

  return (
    <>
      <LeftHalfLayout className={className}>
        <CheckoutNavigationBar checkoutNavigationBarTabValue={checkoutNavigationBarTabValue} />
        {children}
      </LeftHalfLayout>
      <RightHalfLayout>
        <OrderSummary cart={customerCart} />
        <PromoCodeContainer cart={customerCart} />
        <CartItemsSummary cart={customerCart} />
      </RightHalfLayout>
    </>
  )
}

CheckoutLayout.defaultProps = {
  className: '',
}

export default CheckoutLayout
